import { GetUserProfileCertificatesQuery } from './useUserProfileCertificates';

export const updateUserProfileCertificateNudgesCache = ({
  cache,
  nudgeIds,
  userUri
}) => {
  const cachedData = cache.readQuery({
    query: GetUserProfileCertificatesQuery,
    variables: { userUri }
  });
  const cachedUserNudges = cachedData?.userNudges || {};
  const cachedCertificateNudges = cachedUserNudges?.certificateNudges || [];

  const removedNudgeIdMap = nudgeIds.reduce((acc, nudgeId) => {
    acc[nudgeId] = true;

    return acc;
  }, {});

  cache.writeQuery({
    query: GetUserProfileCertificatesQuery,
    variables: { userUri },
    data: {
      userNudges: {
        ...cachedUserNudges,
        id: userUri,
        certificateNudges: cachedCertificateNudges.filter(
          certificateNudge => !removedNudgeIdMap[certificateNudge.nudgeId]
        )
      }
    }
  });
};

export const clearUserProfileCertificateNudgesCache = ({ cache, userUri }) => {
  const cachedData = cache.readQuery({
    query: GetUserProfileCertificatesQuery,
    variables: { userUri }
  });

  const cachedUserNudges = cachedData?.userNudges || {};

  cache.writeQuery({
    query: GetUserProfileCertificatesQuery,
    variables: { userUri },
    data: {
      userNudges: {
        ...cachedUserNudges,
        id: userUri,
        certificateNudges: []
      }
    }
  });
};
